import React from "react"
/** @jsx jsx */
import { css,  jsx } from '@emotion/react'
import Card from "../../components/commons/inspiration-card"
import { CardsContainer } from "../../components/commons/cards-container"
import Container from "../../components/commons/container"

const InspirationsContainer =  ({ data }) => {
  return (
    <Container
      css={css`
        padding: 48px 25px;

        @media (min-width: 1250px) {
          margin: 0 auto;
          padding: 48px 0 40px;
        }
      `}
    >
      <CardsContainer css={
          css`
            grid-template-columns: repeat(1, 1fr);

            @media (min-width: 768px) {
              grid-template-columns: repeat(2, 1fr);
            }
          `
        }>
        {data.edges.map((post, i) => (
          <Card key={i} post={post.node} />
        ))}
      </CardsContainer>
    </Container>
  )
}

export default InspirationsContainer